import React from 'react';

const TasksTable = () => {
    function createData(title, status ) {
        return { title, status, };
      }
      
    const dummyTasks = [
        createData('Door Handles and Pushplates', "In progress"),
        createData('Light Switches', "In progress"),
        createData('Meeting Room', "In progress"),
        createData('CourtYard', "In progress"),
        createData('Function Room',"In progress"),
        createData('Spa',"In progress"),

    ];

    return(
        <div className="snapboard-table">
            <div className="table-header">
                <h3>
                    Task
                    <span>
                    (these are sample hygiene tasks which you can edit later)
                    </span>
                </h3>
                <h3>Last attended</h3>
            </div>
            <div className="table-body">
                {
                    dummyTasks.map((task) => {
                        return (
                            <div className="snapboard-table-row" key={task.title}>
                                <div className="job-name-cell">
                                    {task.title}
                                </div>
                                <div className="job-info-cell">
                                    {task.status}
                                </div>
                            </div>
                        )

                    })
                }
            </div>
        </div>
    )

};

export default TasksTable;